/**
 * Filers and reduces user groups, and returns a permission object
 * @param {Object} user - result from getUser query
 * @returns {Object} permissions
 */
export const parsePermList = user => {
  const permissions = (user.groups || [])
    .filter(g => Object.keys(g.permissions).length > 0)
    .reduce((obj, g) => ({ ...obj, ...g.permissions }), {})

  return permissions
}

export default {
  parsePermList
}



// WEBPACK FOOTER //
// ./src/utils/user.js